import { useCurrentUser } from "./useCurrentUser";

export function useCurrentUserTheme() {
  return useCurrentUser()?.theme;
}
